import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_op_address = _resolveComponent("op-address")!

  return (_openBlock(), _createBlock(_component_op_address, {
    modelValue: _ctx.localValue.address,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue.address) = $event)),
    showAsterisks: _ctx.showAsterisks,
    label: "Indirizzo di fatturazione"
  }, null, 8, ["modelValue", "showAsterisks"]))
}